/**
 * Haptic feedback wrapper for Telegram Mini App.
 * Safe when Telegram.WebApp is unavailable (e.g. in browser dev).
 */
const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;

export const haptic = {
  /** Нажатие на карточку, кнопку */
  tap: () => tg?.HapticFeedback?.impactOccurred('light'),

  /** Лайк, реакция, важное действие */
  action: () => tg?.HapticFeedback?.impactOccurred('medium'),

  /** Успешная публикация, отправка */
  success: () => tg?.HapticFeedback?.notificationOccurred('success'),

  /** Ошибка валидации */
  error: () => tg?.HapticFeedback?.notificationOccurred('error'),

  /** Переключение таба, фильтра, селектора */
  select: () => tg?.HapticFeedback?.selectionChanged(),

  /** Предупреждение (удаление) */
  warning: () => tg?.HapticFeedback?.notificationOccurred('warning'),
};
